module.exports = __webpack_public_path__ + "img/computer_upload_icon.f6fd1408.svg";